import Homepage from 'pages/homepage';
import KanbanBoard from '../pages/tasks/kanbanBoard';
import TasksList from '../pages/tasks/tasksList';
import TasksCreate from '../pages/tasks/createTask';
import EditTask from '../pages/tasks/editTask';
import EditProfile from '../pages/user/editProfile';
import Meetings from '../pages/meetings/listMeetings';
import Meeting from '../pages/meetings/meeting';
import createMeeting from '../pages/meetings/createMeeting';
import editMeeting from '../pages/meetings/editMeeting';
import Changelog from '../pages/support/changelog';
// import CreateGuideline from 'pages/guideline/createGuideline';
import KanbanGuideline from 'pages/guideline/kanbanGuideline';
import GuidelinesList from 'pages/guideline/guidelinesList';
import ReviewGuideline from 'pages/guideline/reviewGuideline';
import GuidelineApproval from 'pages/guideline/guidelineApproval';
import GuidelineMisc from 'pages/guideline/guidelineMisc';
import CreateContentStructure from 'pages/guideline/createContentStructure';
import PreReviewContent from 'pages/guideline/preReviewContent';
import ReviewContent from 'pages/guideline/reviewContent';
import InternalApproval from 'pages/guideline/internalApproval';
import PublishContent from 'pages/guideline/publishContent';
import ContentApproval from 'pages/guideline/contentApproval';
import ViewPublishedContent from 'pages/guideline/viewPublishedContent';
import KeywordMonitoring from 'pages/keywords/keywordMonitoring';
import KeywordGroups from 'pages/keywords/keywordGroups';
import KeywordGroup from 'pages/keywords/keywordGroup';
// import KanbanBoardPaidMedia from 'pages/paidMedia/kanbanBoard';
// import KanbanBoardSEO from 'pages/seo/kanbanBoard';
// import KanbanListSEO from 'pages/seo/list';
import ActivitiesList from 'pages/guideline/activitiesList';
import TestKanbanBoard from 'pages/temp-seo/kanbanBoard';
import TestTasksList from 'pages/temp-seo/tasksList';
import GuidelinesListBeta from 'pages/guidelineNew/GuidelinesListBeta';
import CreateGuidelineBeta from 'pages/guidelineNew/CreateGuidelineBeta';
import ContentApprovalBeta from 'pages/guidelineNew/ContentApprovalBeta';
import {
  RedirectToNewGuidelines,
  RedirectToNewCreateGuideline,
  RedirectToNewGuideline,
} from './redirects';
const authProtectedRoutes = [
  // Homepage
  { path: '/', component: Homepage },
  { path: '/edit-profile', component: EditProfile },
  // Tasks
  {
    path: '/old-tasks',
    component: KanbanBoard,
    requiredModule: 'tasks',
    requiredRole: 'Super Admin',
  },
  // { path: '/tasks-list', component: TasksList },
  // { path: '/tasks-create', component: TasksCreate },
  // { path: '/edit-task', component: EditTask },
  // Test SEO Tasks
  { path: '/tasks', component: TestKanbanBoard },
  { path: '/tasks-list', component: TestTasksList },
  // Meetings
  { path: '/meetings', component: Meetings, requiredModule: 'meetings', isUserOnlyModule: true },
  { path: '/meeting', component: Meeting, requiredModule: 'meetings', isUserOnlyModule: true },
  // Meeting Management
  {
    path: '/create-meeting',
    component: createMeeting,
    requiredModule: 'meetings',
    isUserOnlyModule: true,
  },
  {
    path: '/edit-meeting',
    component: editMeeting,
    requiredModule: 'meetings',
    isUserOnlyModule: true,
  },
  // Changelog
  { path: '/changelog', component: Changelog },
  // Guidelines
  {
    path: '/guidelines',
    component: GuidelinesListBeta,
    requiredModule: 'content',
    requiredRole: ['Super Admin', 'Admin'],
  },
  {
    path: '/guideline/:id',
    component: ContentApprovalBeta,
    requiredModule: 'content',
    requiredRole: ['Super Admin', 'Admin'],
  },
  {
    path: '/create-guideline',
    component: CreateGuidelineBeta,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  // Redirects from the old beta paths
  { path: '/guidelines-list-beta', component: RedirectToNewGuidelines },
  { path: '/create-guideline-beta', component: RedirectToNewCreateGuideline },
  { path: '/guideline-beta/:id', component: RedirectToNewGuideline },
  {
    path: '/old-guidelines',
    component: KanbanGuideline,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/old-guidelines-list',
    component: GuidelinesList,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/old-guideline/:id',
    component: GuidelineMisc,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  // {
  //   path: '/create-guideline',
  //   component: CreateGuideline,
  //   requiredModule: 'content',
  //   requiredRole: 'Super Admin',
  // },
  {
    path: '/old-guideline/manage',
    component: ActivitiesList,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/old-guideline/:id/review',
    component: ReviewGuideline,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/old-guideline/:id/guideline-approval',
    component: GuidelineApproval,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/structure',
    component: CreateContentStructure,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/pre-review',
    component: PreReviewContent,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/review',
    component: ReviewContent,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/internal-approval',
    component: InternalApproval,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/content-approval',
    component: ContentApproval,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/publish',
    component: PublishContent,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  {
    path: '/content/:id/published-content',
    component: ViewPublishedContent,
    requiredModule: 'content',
    requiredRole: 'Super Admin',
  },
  // Reports
  { path: '/reports/keywords', component: KeywordMonitoring },
  { path: '/reports/keywords/groups', component: KeywordGroups },
  { path: '/reports/keywords/groups/:id', component: KeywordGroup },
  // Paid Media
  // { path: '/campaigns', component: KanbanBoardPaidMedia },
  // SEO
  // { path: '/new-tasks', component: KanbanBoardSEO },
  // { path: '/new-tasks-list', component: KanbanListSEO },
];

export { authProtectedRoutes };
